import * as React from "react";

import { signInWithCustomToken, signInWithEmailAndPassword } from "firebase/auth";

import { LoginFormFields } from "./loginForm.types";
import { auth } from "../../../firebase-config";
import { useAlert } from "hooks";
import { useNavigate } from "react-router-dom";

export const useLoginForm = (authToken: string | undefined) => {
  const navigate = useNavigate();
  const { openAlert, handleOpenAlert, handleCloseAlert, alertMessage, setAlertMessage } = useAlert();

  const [loading, setLoading] = React.useState<boolean>(false);

  const handleTokenLogin = async () => {
    setLoading(true);
    if (authToken) {
      try {
        await signInWithCustomToken(auth, authToken);
        // console.log(response);
        navigate("/products");
      } catch (error: any) {
        handleOpenAlert();
        switch (error.code) {
          case "auth/invalid-custom-token":
            setAlertMessage({
              title: "Atenție",
              message: "Token de autentificare greșit!",
              color: "danger",
            });
            break;
          case "auth/custom-token-mismatch":
            setAlertMessage({
              title: "Atenție",
              message: "Token-ul generat are un format neașteptap!",
              color: "danger",
            });
            break;
          case "auth/user-disabled":
            setAlertMessage({
              title: "Atenție",
              message: "Acest cont este dezactivat!",
              color: "danger",
            });
            break;
          case "auth/operation-not-allowed":
            setAlertMessage({
              title: "Atenție",
              message: "Autentificarea prin token nu este posibilă!",
              color: "danger",
            });
            break;
          case "auth/internal-error":
            setAlertMessage({
              title: "Atenție",
              message: "A apărut o eroare internă!",
              color: "danger",
            });
            break;
          default:
            setAlertMessage({
              title: "Atenție",
              message: "A apărut o eroare! Vă rugăm să încercați mai târziu.",
              color: "danger",
            });
        }
      } finally {
        setLoading(false);
      }
    }
  };

  React.useEffect(() => {
    if (authToken) handleTokenLogin();
  }, [authToken]);

  const handleLogin = async (values: LoginFormFields) => {
    if (!authToken) {
      setLoading(true);

      try {
        // User is in web app
        // Sign in user
        await signInWithEmailAndPassword(auth, values.email, values.password);
        navigate("/delete-user");
      } catch (error: any) {
        handleOpenAlert();
        switch (error.code) {
          case "auth/invalid-email":
            setAlertMessage({
              title: "Atenție",
              message: "Email sau parolă greșită!",
              color: "danger",
            });
            break;
          case "auth/user-disabled":
            setAlertMessage({
              title: "Atenție",
              message: "Acest cont este dezactivat!",
              color: "danger",
            });
            break;
          case "auth/user-not-found":
            setAlertMessage({
              title: "Atenție",
              message: "Acest utilizator nu există!",
              color: "danger",
            });
            break;
          case "auth/wrong-password":
            setAlertMessage({
              title: "Atenție",
              message: "Email sau parolă greșită!",
              color: "danger",
            });
            break;
          default:
            setAlertMessage({
              title: "Atenție",
              message: "A apărut o eroare! Vă rugăm să încercați mai târziu.",
              color: "danger",
            });
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return {
    loading,
    handleLogin,
    openAlert,
    handleOpenAlert,
    handleCloseAlert,
    alertMessage,
    setAlertMessage,
  };
};
